import { Input } from '@angular/core';

export abstract class Value<T = any> {

    @Input() public data: T;

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/classes/value.ts